module.exports = __webpack_public_path__ + "static/media/gallery_06_t.088c5f99.jpg";